export { default as HomepageLayout } from './Homepage/Homepage';
export { default as LoginLayout } from './Login/Login';
export { default as Signup } from './Signup/Signup';
export { default as ClassCode } from './ClassCode/ClassCode';
export { default as CommunityLayout } from './Community/Community';
export { default as ArchiveLayout } from './Archive/Archive';
export { default as FacilitatorIntro } from './Facilitator/Facilitator';
export { default as Confirmation } from './Confirmation/Confirmation';
export { default as NewResource } from './Create/NewResource/NewResource';
// export { default as FromActivity } from './Create/FromActivity';
export { default as BoxList } from './BoxList/BoxList';
export { default as WorkspaceLayout } from './Workspace/Workspace';
export { default as About } from './About/About';
export { default as NotFound } from './NotFound/NotFound';
export { default as Terms } from './Terms/Terms';
export { default as Faq } from './Faq/Faq';
export { default as Instructions } from './Instructions/Instructions';
export { default as FacilitatorInstructions } from './Instructions/FacilitatorInstructions';
export { default as Contact } from './Contact/Contact';
export { default as ForgotPassword } from './ForgotPassword/ForgotPassword';
export { default as ResetPasswordLayout } from './ResetPassword/ResetPassword';
// prettier-ignore
export { default as AdminDashboardLayout } from './AdminDashboard/AdminDashboard';
// prettier-ignore
export { default as DashboardBoxList } from './DashboardBoxList/DashboardBoxList';
export { default as SelectableBoxList } from './SelectableBoxList/SelectableBoxList';
export * from './Dashboard';



// WEBPACK FOOTER //
// ./src/Layout/index.js